var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagicWandIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 59,
    viewBox: "0 0 77 59",
    width: 77,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#eb4f92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.5,
    cy: 30.5,
    rx: 26.5,
    ry: 26.5,
    transform: "matrix(-1 0 0 -1 101 61)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.0001,
    cy: 43,
    opacity: 0.3,
    rx: 16,
    ry: 16,
    transform: "matrix(-1 0 0 -1 56.0002 86)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.5001,
    cy: 16.5,
    opacity: 0.12,
    rx: 16.5,
    ry: 16.5,
    transform: "matrix(-1 0 0 -1 43.0002 33)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m46.2048 18.264c0-.5159-.1704-.9466-.5159-1.2921l-5.6845-5.6798c-.3455-.3455-.7762-.5159-1.2921-.5159s-.9466.1752-1.2922.5159l-36.904189 36.9043c-.345518.3455-.515911.7762-.515911 1.2921s.170393.9466.515911 1.2874l5.684489 5.6893c.34552.3455.77624.5159 1.29215.5159s.94662-.1704 1.29214-.5159l36.90901-36.909c.3407-.3455.5111-.7715.5111-1.2922zm-12.8268 8.4108-3.0718-3.0718 8.4108-8.4108 3.0718 3.0718zm-26.80368-9.329.86143-2.8115 2.81145-.8614-2.81145-.8614-.86143-2.8115-.86143 2.8115-2.81148.8614 2.81148.8614zm7.45938 3.5593 1.7229 5.623 1.7229-5.623 5.6229-1.7228-5.6229-1.7229-1.7229-5.6229-1.7229 5.6229-5.62292 1.7229zm30.1312 10.2757-.8567-2.8115-.8615 2.8115-2.8115.8614 2.8115.8614.8615 2.8115.8614-2.8115 2.8115-.8614zm-19.226-13.835.8614-2.8115 2.8115-.8614-2.8115-.8614-.8614-2.8115-.8615 2.8115-2.8162.8614 2.8162.8614z",
    fill: "#f5dfe8",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandIcon);
export default __webpack_public_path__ + "static/media/magic_wand_icon.f9a48cb19cf0bc9ed982dac5fdc3ab28.svg";
export { ForwardRef as ReactComponent };